export type Organization = { id: string; customerId: string; name: string; [key: string]: unknown };

const createAppStore = () => ({
  organizations: [] as Organization[],

  setOrganizations(orgs: Organization[]) {
    this.organizations = orgs;
  },
});

export default createAppStore;
